// extracted by mini-css-extract-plugin
module.exports = {"avatar":"AvatarListItem_avatar__1JCxH","container":"AvatarListItem_container__1JdWl","name":"AvatarListItem_name__2pcf0"};